<form (ngSubmit)="submitEmail(formGroup.value)" autocomplete="off" novalidate>
  <div class="sms" [formGroup]="formGroup">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline" class="demo-chip-list">
            <mat-label>Email address</mat-label>
            <mat-chip-grid #chipList>
              <mat-chip-row
                *ngFor="let email of emailList"
                [removable]="removable"
                (removed)="removeEmailAddress(email)"
                class="ut-email-chip">
                {{email.emailAddress}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip-row>
              <input placeholder="Email address"
                     formControlName="email"
                     [matChipInputFor]="chipList"
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     [matChipInputAddOnBlur]="addOnBlur"
                     (matChipInputTokenEnd)="addEmailAddress($event)" />
            </mat-chip-grid>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline" *ngIf="emailTags && emailTags.length > 0">
            <mat-label>Tag</mat-label>
            <mat-select placeholder="Tag" formControlName="tag" (selectionChange)="selectEmailTag($event.value)">
              <mat-option *ngFor="let tag of emailTags" [value]="tag">
                {{tag}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.get('tag').hasError('required')">
              Please select a tag
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline" *ngIf="activeLook === 'crumbs' || !activeLook">
            <mat-label>Template</mat-label>
            <mat-select placeholder="Template" formControlName="template" (selectionChange)="selectEmailTemplate($event.value)">
              <mat-optgroup [label]="'Your templates'" *ngIf="filteredMyTemplates.length > 0">
                <mat-option *ngFor="let template of filteredMyTemplates" [value]="template">
                  {{ template.name }}
                </mat-option>
              </mat-optgroup>
              <mat-optgroup [label]="'Global templates'" *ngIf="filteredGlobalTemplates.length > 0">
                <mat-option *ngFor="let template of filteredGlobalTemplates" [value]="template">
                  {{ template.name }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
            <mat-error *ngIf="formGroup.get('template').hasError('required')">
              Please select a template
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="activeLook !== 'crumbs' && activeLook !== 'trax'">
            <mat-label>Template</mat-label>
            <mat-select placeholder="Template" formControlName="template" (selectionChange)="selectEmailTemplate($event.value)">
              <mat-option *ngFor="let template of filteredGlobalTemplates" [value]="template">
                {{ template.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.get('template').hasError('required')">
              Please select a template
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="activeLook === 'trax'">
            <mat-label>Template</mat-label>
            <mat-select placeholder="Template" formControlName="template" (selectionChange)="selectEmailTemplate($event.value)">
              <mat-option *ngFor="let template of traxEmailTemplates" [value]="template">
                {{ template.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.get('template').hasError('required')">
              Please select a template
            </mat-error>

          </mat-form-field>


          <ng-container *ngIf="filteredGlobalTemplates.length === 0 && formGroup.value.tag  && !templateLoading">
            <mat-error><small>No templates tagged under "{{formGroup.value.tag}}"</small></mat-error>
          </ng-container>

        </div>
      </div>
      <div class="row">
        <div class="col-10">
          <mat-form-field appearance="outline" class="example-chip-list">
            <mat-label>Attachments</mat-label>
            <mat-chip-grid #attachmentList>
              <mat-chip-row *ngFor="let attachment of attachments" [removable]="removable" (removed)="removeAttachment(attachment)">
                {{attachment.name}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip-row>
              <input placeholder="Attachments"
                     [matChipInputFor]="attachmentList"
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     [matChipInputAddOnBlur]="addOnBlur" readonly>
              <input type="file" id="attachment" formControlName="attachment" (change)="onFileChange($event)" style="display: none;" multiple>
            </mat-chip-grid>
          </mat-form-field>
        </div>
        <div class="col-2">
          <button mat-raised-button class="mt-2" type="button" color="primary" (click)="openFileBrowser($event)">Add</button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Subject</mat-label>
            <input matInput placeholder="Subject" formControlName="subject">
            <mat-error *ngIf="formGroup.get('subject').hasError('required')">
              Please input a subject
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <angular-editor formControlName="body" [config]="editorConfig"></angular-editor>
          <mat-error *ngIf="formGroup.get('body').hasError('required')">
            Please input a message body
          </mat-error>
        </div>
      </div>
      <div class="row pt-2 pb-2">
        <div class="col-sm-6">
        </div>
        <div class="col-sm-6 text-end">
          <button mat-raised-button type="submit" color="primary" cdkFocusInitial>Submit</button>
        </div>
      </div>
    </div>
  </div>
</form>
